<template>
  <div class="tm-date-picker">
    <div v-if="type === 'date'" class="tm-time-container">
      <el-date-picker type="date" class="tm-starttime-container" :editable="editable" :clearable="clearable" :picker-options="startPickerOptions" v-model="startTime" placeholder="开始日期" value-format="yyyy-MM-dd" @change="startTimeChange"></el-date-picker>
      <div class="tm-separate-container">至</div>
      <el-date-picker type="date" class="tm-endtime-container" :editable="editable" :clearable="clearable" :picker-options="endPickerOptions" v-model="endTime" placeholder="结束日期" value-format="yyyy-MM-dd" @change="endTimeChange"></el-date-picker>
    </div>
    <div v-else class="tm-time-container">
      <el-date-picker class="tm-starttime-container" :editable="editable" type="datetime" :clearable="clearable" :picker-options="startPickerOptions" v-model="startTime" placeholder="开始日期" value-format="yyyy-MM-dd HH:mm:ss" @change="startTimeChange"></el-date-picker>

      <div class="tm-separate-container">至</div>

      <el-date-picker class="tm-endtime-container" :editable="editable" type="datetime" :clearable="clearable" :picker-options="endPickerOptions" v-model="endTime" placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="endTimeChange"></el-date-picker>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'date'
    },
    editable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: Array
  },
  data() {
    return {
      startTime: '',
      endTime: ''
    }
  },
  computed: {
    startPickerOptions() {
      var _this = this
      return {
        disabledDate(time) {
          if (time.getTime() > Date.now()) {
            return true
          }
          if (_this.endTime !== '' && _this.endTime !== null) {
            return time.getTime() >= new Date(_this.endTime).getTime()
          }
        }
      }
    },
    endPickerOptions() {
      var _this = this
      return {
        disabledDate(time) {
          // if (time.getTime() > Date.now()) {
          //   return true
          // }
          if (_this.startTime !== '' && _this.startTime !== null) {
            if (_this.type !== 'date') {
              return time.getTime() < new Date(_this.startTime).getTime()
            }
            return time.getTime() < new Date(_this.startTime).getTime() - 1000 * 60 * 60 * 24
          }
        }
      }
    }
  },
  methods: {
    startTimeChange(startTime) {
      var time = []
      if (!(this.value instanceof Array)) {
        time = [startTime, '']
      } else {
        time = [startTime, this.value[1]]
      }
      this.$emit('input', time)
      this.$emit('change', [this.startTime, this.endTime])
    },
    endTimeChange(endTime) {
      var time = []
      if (!(this.value instanceof Array)) {
        time = ['', endTime]
      } else {
        time = [this.value[0], endTime]
      }
      this.$emit('input', time)
      this.$emit('change', [this.startTime, this.endTime])
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val, oldVal) {
        if (val instanceof Array && val.length === 2) {
          this.startTime = val[0]
          this.endTime = val[1]
        } else {
          this.startTime = ''
          this.endTime = ''
        }
      }
    }
  }
}
</script>
<style lang="scss">
.tm-date-picker .tm-time-container .tm-starttime-container,
.tm-date-picker .tm-time-container .tm-endtime-container {
  display: inline-block;
  width: 45%;
}
.tm-date-picker .tm-time-container .tm-endtime-container {
  float: right;
}
.tm-date-picker .tm-time-container .tm-separate-container {
  display: inline-block;
  width: 8%;
  text-align: center;
}
</style>
